<scaffold-dialog [title]="data.title" [size]="data.size||'half'">
  <div scaffoldDialogBody>
    <p>{{'grade_data_export'| translation}}</p>
    <ul [ngClass]="{'disabled':exportStarted}">
      <li *ngFor="let export of courseExports"><a (click)="getData(export.type,export.format)">{{export.label}}</a></li>
    </ul>
    <p>{{'individual_student_data'| translation}}</p>
    <ul [ngClass]="{'disabled':exportStarted}">
      <li *ngFor="let export of studentExports"><a (click)="byStudent(export.type,export.format)">{{export.label}}</a></li>
    </ul>
  </div>
  <div scaffoldDialogButtons>
    <button nbButton status="neutral" (click)="dialogRef.close()">{{'close'| translation}}</button>
  </div>
</scaffold-dialog>
